<template>
  <span id="shipment-detail-dialog">
    <i class="el-icon-search header-info-dialog-value icon-action" id="btn-shipment-load-detail" @click="handleOpenDialog" size="mini" icon="el-icon-plus"></i>
    <el-dialog
    :close-on-click-modal="false"
    :title="$t('customerService.shipment.shipmentDetails')"
    :visible.sync="dialogVisible"
    width="85%"
    :before-close="handleClose">
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('customerService.shipment.shipmentNumberShort') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ shipment.currentDetail.header.shipmentNumber }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('customerService.shipment.outboundDate') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ shipment.currentDetail.header.outboundDate | moment("MM/DD/YYYY") }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('customerService.shipment.status') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ shipmentStatusLabel(shipment.currentDetail.header.status) }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('customerService.shipment.shipper') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">
            <el-tooltip class="item" effect="dark" :content="shipment.currentDetail.header.shipperAccountName + ' - ' + shipment.currentDetail.header.shipperAccountNumber" placement="top">
              <span> {{ shipment.currentDetail.header.shipperAccountName }} - {{ shipment.currentDetail.header.shipperAccountNumber }} </span>
            </el-tooltip>
          </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('customerService.shipment.consignee') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">
            <el-tooltip class="item" effect="dark" :content="shipment.currentDetail.header.consigneeAccountName + ' - ' + shipment.currentDetail.header.consigneeAccountNumber" placement="top">
              <span> {{ shipment.currentDetail.header.consigneeAccountName }} - {{ shipment.currentDetail.header.consigneeAccountNumber }} </span>
            </el-tooltip>
          </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('customerService.shipment.deliverTo') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">
            <el-tooltip class="item" effect="dark" :content="shipment.currentDetail.header.deliverToAccountName + ' - ' + shipment.currentDetail.header.deliverToAccountNumber" placement="top">
              <span> {{ shipment.currentDetail.header.deliverToAccountName }} - {{ shipment.currentDetail.header.deliverToAccountNumber }} </span>
            </el-tooltip>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('customerService.shipment.billTo') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">
            <el-tooltip class="item" effect="dark" :content="shipment.currentDetail.header.billToAccountName + ' - ' + shipment.currentDetail.header.billToAccountNumber" placement="top">
              <span> {{ shipment.currentDetail.header.billToAccountName }} - {{ shipment.currentDetail.header.billToAccountNumber }} </span>
            </el-tooltip>
          </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('customerService.shipment.receivingWarehouse') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ shipment.currentDetail.header.receivingWarehouseCode }} </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('customerService.shipment.outboundWarehouse') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ shipment.currentDetail.header.outboundWarehouseCode }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('customerService.shipment.totalCubes') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">
            <span class="span-small-list"> {{ shipment.currentDetail.header.cubes ? shipment.currentDetail.header.cubes.toFixed(2) : '0' }} </span>
          </span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('outbound.units.unitOfMeasure') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">
            <span class="span-small-list"> {{ unitOfMeasureLabel(shipment.currentDetail.header.unitOfMeasureId) }} </span>
          </span>
        </el-col>
         <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('customerService.billOfLading.loadNumber') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ shipment.currentDetail.header.loadNumber }} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('customerService.billOfLading.bolNumber') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list"> {{ shipment.currentDetail.header.bolNumber }} </span>
        </el-col>
      </el-row>
      <br/>
      <el-tabs v-model="selectedTab" type="border-card" @tab-click="searchTabInfo">
        <el-tab-pane name="details-tab" :label="$t('customerService.shipment.details')">
          <details-summary :shipment-id="shipmentId" :shipment-status="shipment.currentDetail.header.status" ref="detailsSummary" />
        </el-tab-pane>
        <el-tab-pane name="rating-tab" :label="$t('customerService.shipment.rating')" >
          <rating-summary :shipment-id="shipmentId" ref="ratingSummary" />
        </el-tab-pane>
      </el-tabs>
      <div id="shipment-details-dialog-footer" slot="footer" class="dialog-footer form-vertical-item">
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import unitDataTransformLabels from '@/plugins/unitDataTransformLabels';
import constants from '@/utils/constants';
import RatingSummary from './RatingSummary';
import DetailsSummary from './DetailsSummary';

const tabDetailsName = 'details-tab';
const tabRatingsName = 'rating-tab';
export default {
  name: 'ShipmentDetailDialog',
  mixins: [unitDataTransformLabels],
  components: { DetailsSummary, RatingSummary },
  computed: {
    ...mapGetters([
      'shipment'
    ])
  },
  props: {
    shipmentId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      selectedTab: tabDetailsName
    };
  },
  methods: {
    handleClose(done) {
      this.$store.dispatch('shipment/search', {});
      done();
    },
    handleOpenDialog() {
      this.selectedTab = tabDetailsName;
      this.dialogVisible = true;
      this.searchDetail();
    },
    async searchDetail() {
      await this.$store.dispatch('shipment/searchHeader', this.shipmentId);
      await this.$nextTick();
      this.$refs.detailsSummary.setShowCancelled(this.shipment.currentDetail.header.status === constants.SHIPMENT.STATUS[6].value ? 1 : 0);
      this.$refs.detailsSummary.handleSearchChangePage(constants.TABLES.DEFAULT_PAGE);
      this.$refs.ratingSummary.setShowRateWithZero(false);
    },
    searchTabInfo(tab) {
      if (tab) {
        if (tab.name === tabRatingsName) {
          this.$refs.ratingSummary.handleSearchChangePage(constants.TABLES.DEFAULT_PAGE);
        } else {
          this.$refs.detailsSummary.handleSearchChangePage(constants.TABLES.DEFAULT_PAGE);
        }
      }
    }
  }
};
</script>
